import { CalendarItemKind } from '../../../../constants/calendar'
import { CALENDAR_DAY_LOAD_TAG_COLORS } from '../../Calendar.constants'

import { toCalendarGridAppointment } from './useCalendarItemsLoader.utils.appointments'
import {
  toCalendarGridFollowUp,
  toCalendarGridFollowUpDay,
} from './useCalendarItemsLoader.utils.followups'
import {
  toCalendarGridTaskDeadline,
  toCalendarGridTaskGroup,
} from './useCalendarItemsLoader.utils.tasks'

function getHasCalendarDayLoadLimit(load) {
  return load.limit !== null
}

function toCalendarGridDayLoad({ load, t }) {
  const params = { limit: load.limit, used: load.follow_up_count }

  return {
    ...params,
    isFull: load.is_full,
    laneLabel: t('Calendar.DayFullKey', params),
    loadLabel: t('Calendar.DayFullShortKey', params),
    monthLabel: t('Calendar.DayFullShortKey', params),
    summary: t('Calendar.DayLoadHeaderKey', params),
    tag: { ...CALENDAR_DAY_LOAD_TAG_COLORS, text: t('Calendar.FollowUpsKey') },
  }
}

export function toCalendarGridItem({ item, t, timezone }) {
  switch (item.kind) {
    case CalendarItemKind.appointment:
      return toCalendarGridAppointment({ item, timezone })
    case CalendarItemKind.followUp:
      return toCalendarGridFollowUp(item, t)
    case CalendarItemKind.followUpDay:
      return toCalendarGridFollowUpDay(item, t)
    case CalendarItemKind.taskGroup:
      return toCalendarGridTaskGroup(item, t)
    default:
      return toCalendarGridTaskDeadline(item, t)
  }
}

export function toCalendarGridDayLoads({ dayLoad, t }) {
  return Object.fromEntries(
    dayLoad
      .filter(getHasCalendarDayLoadLimit)
      .map(load => [load.date, toCalendarGridDayLoad({ load, t })])
  )
}
